import { trackEvent } from './countly';

export const trackLearningCardClicked = (title: string): void =>
  trackEvent({
    key: '[Standard Assignment] Clicked learning card',
    segmentation: { title },
  });
